import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions({
      mixSaveTableCurrentFilters(dispatch, model) {
        return dispatch(`models/${model}/saveTableCurrentFilters`);
      },
      mixRetrieveTablePreviousFilters(dispatch, model) {
        return dispatch(`models/${model}/retrieveTablePreviousFilters`);
      },
    }),
  },
};
